export default {
  data: function () {
    return {
      presenceValidation: (value) => !!value || '必ず入力してください',
      presenceArrayValidation: (value) => value.length !== 0 || '必ず選択してください',
      urlValidation: (value) => {
        if (!value) {
          return true
        }
        const REGEX = /^(https?|ftp)(:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+)$/

        if (value.toString().match(REGEX)) {
          return true
        } else {
          return '有効なURLを入力してください'
        }
      },
      positiveNumberPresenceValidation: (value) => {
        return /^\d*$/.test(value) || '必ず0以上の数字を入力してください'
      },
      moreThanMinimumNumberValidation: (min) => (value) => {
        return (
          !value || value >= min || `必ず${min}以上の数字を入力してください`
        )
      },
      passwordValidation: (value) => {
        const regex = new RegExp(
          '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[#?!@$%^&*-])(?=.{8,128})'
        )
        if (!value || !(value.length >= 8 && value.length <= 128)) {
          return 'パスワードは8~128字以内で設定してください'
        } else if (!regex.test(value)) {
          return 'パスワードは半角数字・半角英小文字・半角英大文字・半角記号（#?!@$%^&*-）をそれぞれ含んでください。'
        } else {
          return true
        }
      },
      confirmationPasswordValidation: (value, newPassword) => {
        if (!value || value !== newPassword) {
          return '確認用パスワードが新しいパスワードと異なります'
        } else {
          return true
        }
      },
      stringLengthValidation: (value, maximumValue) => {
        if (!value || value.length <= maximumValue) {
          return true
        } else {
          return `${maximumValue}文字以下で設定してください`
        }
      },
      colorCodeValidation: (arrowBlank) => (value) => {
        if (arrowBlank && !value) return true

        if (!this.isColorHex(value)) {
          return 'HEX値を入力してください'
        } else {
          return true
        }
      },
      sizeValidation: (value) => {
        if (value && value.size > 5000000) {
          return '画像サイズは5MB未満にして下さい'
        } else {
          return true
        }
      },
      hiraganaOnlyValidation: (value) => {
        if (!value) {
          return true
        }
        const REGEX = /^[ぁ-んー－]+$/

        if (value.toString().match(REGEX)) {
          return true
        } else {
          return 'ひらがなを入力してください'
        }
      }
    }
  },
  methods: {
    isColorHex (value) {
      return value.match(/^#([0-9a-fA-F]{6})$/) != null
    }
  }
}
